import { Component, ChangeDetectionStrategy } from '@angular/core';
import { FormControl } from '@angular/forms';
import { FieldTypeConfig, FieldType, FormlyFieldProps } from '@ngx-formly/core';

interface RadioProps extends FormlyFieldProps {
    formCheck?: 'default' | 'inline';
}

@Component({
  standalone: false,
    selector: "formly-field-button-radio",
    templateUrl: "./button-radio.component.html",
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormlyFieldButtonRadio extends FieldType<FieldTypeConfig<RadioProps>> {
    override defaultOptions = {
        props: {
            formCheck: 'default' as const,
        },
    };

    get disabledControl() {
        return new FormControl({ value: this.formControl.value, disabled: true });
    }
}